module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon-分享方式-空间.ef488.png";